/**
 * Impostazioni Page - Page Shell
 * Pannello impostazioni con Theme Switcher
 */

import { ImpostazioniPanel } from "@/features/impostazioni";

export default function Impostazioni() {
  return <ImpostazioniPanel />;
}
